import React, { Component } from 'react';
import Popup from './popup';
import Popup1 from './popup1';
import moment from 'moment';
import AlertPopup from './alertPopup';
import { submitClientSOADetails } from '../api/apirequest';
import SignaturePad from 'react-signature-pad-wrapper';
import HelpButton from 'react-bootstrap/Button';
//const imageToBase64 = require('image-to-base64');
import { DatePicker, DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
var Loader = require('react-loader');
const localIpUrl = require('local-ip-url');



export const toDataUrl = (url, callback) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
        const reader = new FileReader();
        reader.onloadend = () => {
            callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
};

class SubmitSOA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            repChkBox: props.soaid !== "" && (props.clientDetails.RepName !== "" || props.clientDetails.RepRelationship !== "") ? true : false,
            showRepresentive: props.soaid !== "" && (props.clientDetails.RepName !== "" || props.clientDetails.RepRelationship !== "") ? "block" : "none",
            showPopup: false,
            alertShowPopup: false,
            Product_PartD: props.soaid !== "" ? props.clientDetails.Product_PartD : true,
            Product_PartC: props.soaid !== "" ? props.clientDetails.Product_PartC : true,
            Product_Dental: props.soaid !== "" ? props.clientDetails.Product_Dental : true,
            Product_Hospital: props.soaid !== "" ? props.clientDetails.Product_Hospital : false,
            Product_Medigap: props.soaid !== "" ? props.clientDetails.Product_Medigap : true,
            loaded: true,
            help: 0,
            ClientInitial: props.soaid !== "" ? props.clientDetails.ClientInitial : "",
            ClientFullName: props.soaid !== "" ? props.clientDetails.ClientFullName : "",
            ClientPhone: props.soaid !== "" ? props.clientDetails.ClientPhone : "",
            ClientAddress: props.soaid !== "" ? props.clientDetails.ClientAddress : "",
            RepName: props.soaid !== "" ? props.clientDetails.RepName : "",
            RepRelationship: props.soaid !== "" ? props.clientDetails.RepRelationship : "",
            AppointmentDate: props.soaid !== "" ? props.clientDetails.AppointmentDate : "",
            MeetingLocation: props.soaid !== "" ? props.clientDetails.MeetingLocation : "",
            showAppointmentDtls: (props.soaid !== "" && props.IsAgent === true) ? "block" : "none",
            showSignPad: (props.soaid !== "" && props.IsAgent === true) ? "none" : "block",
            readOnlyFlag: (props.soaid !== "" && props.IsAgent === true) ? true : false,
            IsAgent: props.IsAgent,
            soaid: props.soaid,
            plansAgentRepresented: props.soaid !== "" ?
                (props.clientDetails.Product_PartD === true ? "PDP," : "") +
                (props.clientDetails.Product_PartC === true ? "MA/MAPD," : "") +
                (props.clientDetails.Product_Dental === true ? "DENTAL/VISION/HEARING," : "") +
                (props.clientDetails.Product_Hospital === true ? "HOSPITAL INDEMNITY," : "") +
                (props.clientDetails.Product_Medigap === true ? "MEDSUP," : "") + "  "
                : "",
            initialMethodOfContact: "",
            dateAppointmentCompleted: moment().format("MM/DD/YYYY"),
            SignatureDate: props.soaid !== "" && props.IsAgent === true ? moment(props.clientDetails.CreatedDate).format("MM/DD/YYYY") : moment().format("MM/DD/YYYY"),
            IPAddress: props.soaid !== "" && props.IsAgent === true ? props.clientDetails.IPAddress : (props.ip !== undefined ? props.ip : localIpUrl('public')),
            SignPadReadOnly: props.soaid !== "" && props.IsAgent === true ? { padding: "15px 15px 0px 15px", zIndex: -5 } : { padding: "15px 15px 0px 15px" }

        }
    }

    componentDidMount() {
        console.log("did");
        //this.loadClientData();

    }

    loadClientData() {
        if (this.props.IsAgent === true) {

        }
    }

    ChkRepresentive(chkStatus) {
        console.log(chkStatus.currentTarget.checked);
        this.setState({
            showRepresentive: (chkStatus.currentTarget.checked ? "block" : "none"),
            repChkBox: chkStatus.currentTarget.checked
        });
    }

    chkValidation(e) {

        this.state.ClientPhone = this.state.ClientPhone.replace(/[^a-zA-Z0-9]/g, '');

        //  e.preventDefault();
        if (this.state.Product_PartD === false && this.state.Product_PartC === false && this.state.Product_Dental === false && this.state.Product_Hospital === false && this.state.Product_Medigap === false) {
            e.preventDefault();
            alert('Please choose minimum one Product');
            return false
        }
        else if (this.state.ClientInitial === null || this.state.ClientInitial === "") {
            e.preventDefault();
            alert('Please fill Beneficiary Initial');
            return false
        }
        else if ((this.state.ClientInitial !== null || this.state.ClientInitial !== "") && (this.state.ClientInitial.includes("'") || this.state.ClientInitial.includes("\\") || this.state.ClientInitial.includes("%") || this.state.ClientInitial.includes("*") || this.state.ClientInitial.includes("<") || this.state.ClientInitial.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Beneficiary Initial');
            return false
        }
        else if (this.state.ClientFullName === null || this.state.ClientFullName === "") {
            e.preventDefault();
            alert('Please fill Beneficiary Name');
            return false
        }
        else if ((this.state.ClientFullName !== null || this.state.ClientFullName !== "") && (this.state.ClientFullName.includes("'") || this.state.ClientFullName.includes("\\") || this.state.ClientFullName.includes("%") || this.state.ClientFullName.includes("*") || this.state.ClientFullName.includes("<") || this.state.ClientFullName.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Beneficiary Name');
            return false
        }
        else if (this.state.ClientPhone === null || this.state.ClientPhone === "") {
            e.preventDefault();
            alert('Please fill Beneficiary Phone');
            return false
        }
        else if ((this.state.ClientPhone !== null || this.state.ClientPhone !== "") && (this.state.ClientFullName.includes("'") || this.state.ClientFullName.includes("\\") || this.state.ClientFullName.includes("%") || this.state.ClientFullName.includes("*") || this.state.ClientFullName.includes("<") || this.state.ClientFullName.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Phone number');
            return false
        }
        else if (this.state.ClientPhone.match(/[^0-9+-]/)) {
            alert('Please provide valid Phone number');

            return false
        }
        else if (this.state.ClientAddress === null || this.state.ClientAddress === "") {
            e.preventDefault();
            alert('Please fill Beneficiary Address');
            return false
        }
        else if ((this.state.ClientAddress !== null || this.state.ClientAddress !== "") && (this.state.ClientAddress.includes("'") || this.state.ClientAddress.includes("\\") || this.state.ClientAddress.includes("%") || this.state.ClientAddress.includes("*") || this.state.ClientAddress.includes("<") || this.state.ClientAddress.includes(">") || this.state.ClientAddress.includes("@"))) {
            e.preventDefault();
            alert('Please remove special character in Beneficiary Address');
            return false
        }
        else if (this.props.IsAgent === false && this.signaturePad.isEmpty()) {
            e.preventDefault();
            alert('Please fill Beneficiary Signature');
            return false
        }
        else if (this.state.showRepresentive === "block" && (this.state.RepName === null || this.state.RepName === "")) {
            e.preventDefault()
            alert('Please fill Representative Name');
            return false
        }
        else if ((this.state.showRepresentive === "block" && (this.state.RepName !== null || this.state.RepName !== "")) && (this.state.RepName.includes("'") || this.state.RepName.includes("\\") || this.state.RepName.includes("%") || this.state.RepName.includes("*") || this.state.RepName.includes("<") || this.state.RepName.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Representative’s Name');
            return false
        }
        else if (this.state.showRepresentive === "block" && (this.state.RepRelationship === null || this.state.RepRelationship === "")) {
            e.preventDefault()
            alert('Please fill Your Relationship to the Beneficiary');
            return false
        }
        else if ((this.state.showRepresentive === "block" && (this.state.RepRelationship !== null || this.state.RepRelationship !== "")) && (this.state.RepRelationship.includes("'") || this.state.RepRelationship.includes("\\") || this.state.RepRelationship.includes("%") || this.state.RepRelationship.includes("*") || this.state.RepRelationship.includes("<") || this.state.RepRelationship.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Your Relationship to the Beneficiary');
            return false
        }
        else if ((this.state.AppointmentDate !== null || this.state.AppointmentDate !== "") && (this.state.AppointmentDate.includes("'") || this.state.AppointmentDate.includes("\\") || this.state.AppointmentDate.includes("%") || this.state.AppointmentDate.includes("*") || this.state.AppointmentDate.includes("<") || this.state.AppointmentDate.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Appointment Requested Date and Time');
            return false
        }
        else if ((this.state.MeetingLocation !== null || this.state.MeetingLocation !== "") && (this.state.MeetingLocation.includes("'") || this.state.MeetingLocation.includes("\\") || this.state.MeetingLocation.includes("%") || this.state.MeetingLocation.includes("*") || this.state.MeetingLocation.includes("<") || this.state.MeetingLocation.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Meeting Location');
            return false
        }
        else if (this.state.showAppointmentDtls === "block" && (this.state.plansAgentRepresented === null || this.state.plansAgentRepresented === "")) {
            e.preventDefault()
            alert('Please fill Your Relationship to the Beneficiary');
            return false
        }
        else if ((this.state.showAppointmentDtls === "block") && (this.state.plansAgentRepresented !== null || this.state.plansAgentRepresented !== "") && (this.state.plansAgentRepresented.includes("'") || this.state.plansAgentRepresented.includes("\\") || this.state.plansAgentRepresented.includes("%") || this.state.plansAgentRepresented.includes("*") || this.state.plansAgentRepresented.includes("<") || this.state.plansAgentRepresented.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Plan(s) the agent represented');
            return false
        }
        else if (this.state.showAppointmentDtls === "block" && (this.state.initialMethodOfContact === null || this.state.initialMethodOfContact === "")) {
            e.preventDefault()
            alert('Please fill Initial Method of Contact');
            return false
        }
        else if ((this.state.showAppointmentDtls === "block") && (this.state.initialMethodOfContact !== null || this.state.initialMethodOfContact !== "") && (this.state.initialMethodOfContact.includes("'") || this.state.initialMethodOfContact.includes("\\") || this.state.initialMethodOfContact.includes("%") || this.state.initialMethodOfContact.includes("*") || this.state.initialMethodOfContact.includes("<") || this.state.initialMethodOfContact.includes(">"))) {
            e.preventDefault();
            alert('Please remove special character in Initial Method of Contact');
            return false
        }
        else if (this.state.showAppointmentDtls === "block" && (this.state.dateAppointmentCompleted === null || this.state.dateAppointmentCompleted === "")) {
            e.preventDefault()
            alert('Please fill Date Appointment Completed');
            return false
        }
        else if ((this.state.showAppointmentDtls === "block") && (this.state.dateAppointmentCompleted !== null || this.state.dateAppointmentCompleted !== "") && (this.state.dateAppointmentCompleted === ("Invalid date"))) {
            e.preventDefault();
            alert('Please fill valid date in Date Appointment Completed');
            return false
        }
        else {
            this.onSubmit(e);
        }
    }
    setInputFilter() {
        let value = document.getElementById("myTextBox");
        alert('Please fill Beneficiary Signature');
        //return /^\d*\.?\d*$/.test(value); // Allow digits and '.' only, using a RegExp
    };

    async onSubmit(e) {
        this.setState({ loaded: false })
        var str = this.signaturePad.toDataURL();
        var sign = str.replace("data:image/png;base64,", "");
        let request = {
            ClientSOADetails: {
                AgentSOAID: this.props.agentDetails.AgentSOARowID ?? "",
                AgentSOAWebLink: this.props.agentDetails.AgentSOAWebLink ?? "",
                ClientInitial: this.state.ClientInitial ?? "",
                ClientFullName: this.state.ClientFullName ?? "",
                ClientPhone: this.state.ClientPhone ?? "",
                ClientAddress: this.state.ClientAddress ?? "",
                RepName: this.state.RepName ?? "",
                RepRelationship: this.state.RepRelationship ?? "",
                AppointmentDate: this.state.AppointmentDate ?? "",
                MeetingLocation: this.state.MeetingLocation ?? "",
                Product_PartC: this.state.Product_PartC ?? "",
                Product_PartD: this.state.Product_PartD ?? "",
                Product_Medigap: this.state.Product_Medigap ?? "",
                Product_Hospital: this.state.Product_Hospital ?? "",
                Product_Dental: this.state.Product_Dental ?? "",
                IPAddress: this.state.IPAddress ?? "",
                URLReferrer: (this.props.soaid !== "" && this.props.IsAgent === true) ? this.props.clientDetails.URLReferrer : document.referrer,
                CreatedDate: this.state.SignatureDate ?? "",
                ClientSignature: (this.props.soaid !== "" && this.props.IsAgent === true) ? this.props.clientDetails.ClientSignature : sign,
                ClientSOAID: this.props.soaid ?? "",
                AppointmentCompletedOn: (this.props.soaid !== "" && this.props.IsAgent === true) ? moment(this.state.dateAppointmentCompleted).format("MM/DD/YYYY").toString() : "",
                InitialMethodOfContact: (this.props.soaid !== "" && this.props.IsAgent === true) ? this.state.initialMethodOfContact : "",
                PlansRepresented: (this.props.soaid !== "" && this.props.IsAgent === true) ? this.state.plansAgentRepresented.replace(",  ", " ") : ""

            },
            AgentSOAWebLink: this.props.agentDetails.AgentSOAWebLink ?? "",
            AgentSignFile: this.props.agentDetails.AgentSignFile ?? "",
            AgentFullName: this.props.agentDetails.AgentFullName ?? "",
            AgentPhone: this.props.agentDetails.AgentPhone ?? "",
            AgentEmail: this.props.agentDetails.AgentEmail ?? "",
            AgentNPN: this.props.agentDetails.AgentNPN ?? "",
            IsEdit: this.props.soaid !== "" ? "TRUE" : "FALSE",
            IsAgent: this.props.IsAgent === true ? "TRUE" : "FALSE"
        };
        let status = await submitClientSOADetails(request, this.props.config.WebApiUrl);
        if (status !== 0) {
            //code to disable submit button
            this.setState({ loaded: true, alertShowPopup: true });
        }

    }

    onChange = (e) => {
        //let a = e.target.value.includes("%");
        // if (e.target.value.includes("%")) {
        //     e.preventDefault();

        //     alert("Not allowed %");
        //     e.target.value = "";
        //     return false;
        // }
        if (e.target.id === "initial") {
            this.setState({ "ClientInitial": (e.target.value).toUpperCase() });
        }
        if (e.target.id === "name") {
            this.setState({ "ClientFullName": e.target.value });
        }
        else if (e.target.id === "mobile") {
            this.setState({ "ClientPhone": e.target.value });
        }
        else if (e.target.id === "address") {
            this.setState({ "ClientAddress": e.target.value });
        }
        else if (e.target.id === "representative") {
            this.setState({ "RepName": e.target.value });
        }
        else if (e.target.id === "relationship") {
            this.setState({ "RepRelationship": e.target.value });
        }
        else if (e.target.id === "appointmentDate") {
            this.setState({ "AppointmentDate": e.target.value });
        }
        else if (e.target.id === "meetingLocation") {
            this.setState({ "MeetingLocation": e.target.value });
        }
        else if (e.target.id === "standalone") {
            this.setState({ "Product_PartD": e.target.checked });
        }
        else if (e.target.id === "medicare") {
            this.setState({ "Product_PartC": e.target.checked });
        }
        else if (e.target.id === "plansdental") {
            this.setState({ "Product_Dental": e.target.checked });
        }
        else if (e.target.id === "hospitalindemnity") {
            this.setState({ "Product_Hospital": e.target.checked });
        }
        else if (e.target.id === "medicaresupplement") {
            this.setState({ "Product_Medigap": e.target.checked });
        }
        else if (e.target.id === "plansAgentRepresented") {
            this.setState({ "plansAgentRepresented": e.target.value });
        }
        else if (e.target.id === "initialMethodOfContact") {
            this.setState({ "initialMethodOfContact": e.target.value });
        }
        else if (e.target.id === "dateAppointmentCompleted") {
            this.setState({ "dateAppointmentCompleted": e.target.value });
        }
    }

    signClear() {
        this.signaturePad.clear();
    }
    signDisable() {
        // this.signaturePad.disabled();
        this.signaturePad.off();
    }
    handleSave() {
        if (this.signaturePad.isEmpty()) {
            // eslint-disable-next-line no-alert
            alert('Please provide a signature first.');
            return false
        } else {
            //window.open(this.signaturePad.value);
            alert(String(this.signaturePad.toDataURL()));
        }
    }

    selPrvw() {
        console.log("Preview");
        this.setState({
            showPopup: true
        });
    }

    getPopupResult() {
        this.setState({
            showPopup: false,
            alertShowPopup: false
        });
    }

    getAlertPopupResult(help) {

        if (help === 0) {
            this.setState({
                alertShowPopup: false,
                help: 0
            });
            this.props.getResult();
        }
        else {
            this.setState({
                alertShowPopup: false,
                help: 0
            });

        }
    }

    showHelp() {
        this.setState({
            alertShowPopup: true,
            help: 1
        });
    }

    closeMe() {
        let conf = window.confirm("Are you sure, you want to close this tab?");
        if (conf == true) {
            window.close();
        }
    }


    chekerCheck5() {
        //document.getElementById("medicaresupplement1").checked = true;
        if (document.getElementById("medicaresupplement").checked == true) {
            document.getElementById("medicaresupplement").checked = false;
        } else {
            document.getElementById("medicaresupplement").checked = true;
        }
        this.setState({ "Product_Medigap": document.getElementById("medicaresupplement").checked });
    }

    chekerCheck4() {
        //document.getElementById("medicaresupplement1").checked = true;
        if (document.getElementById("hospitalindemnity").checked == true) {
            document.getElementById("hospitalindemnity").checked = false;
        } else {
            document.getElementById("hospitalindemnity").checked = true;
        }
        this.setState({ "Product_Hospital": document.getElementById("hospitalindemnity").checked });
    }

    chekerCheck3() {
        //document.getElementById("medicaresupplement1").checked = true;
        if (document.getElementById("plansdental").checked == true) {
            document.getElementById("plansdental").checked = false;
        } else {
            document.getElementById("plansdental").checked = true;
        }
        this.setState({ "Product_Dental": document.getElementById("plansdental").checked });
    }

    chekerCheck2() {
        //document.getElementById("medicaresupplement1").checked = true;
        if (document.getElementById("medicare").checked == true) {
            document.getElementById("medicare").checked = false;
        } else {
            document.getElementById("medicare").checked = true;
        }
        this.setState({ "Product_PartC": document.getElementById("medicare").checked });
    }

    chekerCheck1() {
        //document.getElementById("medicaresupplement1").checked = true;
        if (document.getElementById("standalone").checked == true) {
            document.getElementById("standalone").checked = false;
        } else {
            document.getElementById("standalone").checked = true;
        }
        this.setState({ "Product_PartD": document.getElementById("standalone").checked });
    }
    onCalenderChange = (jsDate, dateString) => {

        this.setState({ dateAppointmentCompleted: moment(dateString).format() });
    }
    getAgentPlans() {
        //this.state.plansAgentRepresented.substring(0, this.state.plansAgentRepresented.length() - 1)
        let str = (this.state.plansAgentRepresented).toString();
        if (str != null && str.length() > 0) {
            str = str.substring(0, str.length() - 1);
        }
        return str;
    }
    render() {

        return (
            <div>
                <Loader loaded={this.state.loaded}>
                    {
                        <div>
                            <section>
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12 pm_landingview">
                                            <div>
                                                <h1><strong>Sign SOA Form</strong></h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <section >
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div style={{ "textAlign": "left" }}>
                                                <p className="mobilenotvisible"> The Centers for Medicare and Medicaid Services requires agents to document the scope of a marketing appointment prior to any individual sales meeting to ensure understanding of what will be discussed between the agent and the Medicare beneficiary (or their authorized representative). All information provided on this form is confidential and should be completed by each person with Medicare or his/her authorized representative.</p>
                                                <p style={{ "color": "black", "font-size": "smaller" }} ><b>By signing the form, you agree to a meeting with a sales agent to discuss the types of products you select below.</b> Please note, the person who will discuss the products is either employed or contracted by a Medicare plan. They do <u>not work</u> directly for the Federal government. This individual may also be paid based on your enrollment in a plan. <b>Signing this form does NOT obligate you to enroll in a plan, affect your current or future enrollment status, or enroll you in a Medicare plan. Scope of Appointment documentation is subject to CMS record retention requirements.</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <form name="personForm">
                                <section className="pm_hm_article">
                                    <div className="container">
                                        <div className="row" style={{ border: "#188fa6 1px solid" }}>
                                            <div className="col-md-12" style={{ background: "#188fa6", color: "#FFFFFF", "textAlign": "center", padding: "10px", textAlign: "left" }}>
                                                <div className="row">
                                                    <div className="col">Please indicate below beside the type of product(s) you want the agent to discuss. <a href={"#"} onClick={this.selPrvw.bind(this)}><img src={'./images/i10.png'} alt=""></img></a></div><HelpButton className="btnHelp" variant="warning" disabled={this.state.readOnlyFlag} onClick={this.showHelp.bind(this, 1)}>Click For Help</HelpButton>
                                                </div>
                                            </div>
                                            <div className="row col-md-12 mt-2">
                                                <div className="col-md-6">
                                                    <div className="pm_download_mobileapp_content1 mb-0">
                                                        <table border="0">
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <tr>
                                                                            <td><input type="checkbox" disabled={this.state.readOnlyFlag} defaultChecked={this.state.Product_PartD} name="standalone" id="standalone" onChange={this.onChange.bind(this)} /> <label htmlFor="standalone" className="checker"></label></td>
                                                                            <td className="products" valign="top" onClick={!this.state.readOnlyFlag ? this.chekerCheck1.bind(this) : null}>Stand-alone Medicare Prescription Drug Plans (Part D)</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><input type="checkbox" disabled={this.state.readOnlyFlag} defaultChecked={this.state.Product_PartC} ng-model="medicare" name="medicare" id="medicare" onChange={this.onChange.bind(this)} /> <label htmlFor="medicare" className="checker"></label></td>
                                                                            <td className="products" valign="top" onClick={!this.state.readOnlyFlag ? this.chekerCheck2.bind(this) : null}>Medicare Advantage Plans (Part C)</td>
                                                                        </tr>

                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="pm_download_mobileapp_content1">
                                                        <table border="0">
                                                            <tbody>
                                                                <tr style={{ display: "none" }}>
                                                                    <td><input type="checkbox" disabled={this.state.readOnlyFlag} defaultChecked={this.state.Product_Hospital} ng-model="hospitalindemnity" name="hospitalindemnity" id="hospitalindemnity" onChange={this.onChange.bind(this)} /> <label htmlFor="hospitalindemnity" className="checker"></label></td>
                                                                    <td className="products" valign="top" onClick={!this.state.readOnlyFlag ? this.chekerCheck4.bind(this) : null}>Hospital Indemnity Products</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><input className="custom-control-input" type="checkbox" disabled={this.state.readOnlyFlag} defaultChecked={this.state.Product_Medigap} ng-model="medicaresupplement" name="medicaresupplement" id="medicaresupplement" onChange={this.onChange.bind(this)} /> <label htmlFor="medicaresupplement" className="checker"></label></td>
                                                                    <td className="products" valign="top" onClick={!this.state.readOnlyFlag ? this.chekerCheck5.bind(this) : null}> Medicare Supplement (Medigap) Products</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><input type="checkbox" disabled={this.state.readOnlyFlag} defaultChecked={this.state.Product_Dental} ng-model="plansdental" name="plansdental" id="plansdental" onChange={this.onChange.bind(this)} /> <label htmlFor="plansdental" className="checker"></label></td>
                                                                    <td className="products" valign="top" onClick={!this.state.readOnlyFlag ? this.chekerCheck3.bind(this) : null}>Ancillary Products (Dental/Vision/Hearing Products)</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="pm_hm_article">
                                    <div className="container">
                                        <div className="row" style={{ border: "#188fa6 1px solid" }}>
                                            <div className="col-md-12" style={{ background: "#188fa6", color: "#FFFFFF", "textAlign": "center", padding: "10px", textAlign: "left" }}>
                                                Beneficiary Details
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row mt-2">
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="initial" value={this.state.ClientInitial} className="form-control" maxLength="3" name="initial" type="text" readOnly={this.state.readOnlyFlag} required placeholder="Beneficiary initials" onChange={this.onChange.bind(this)} />
                                                            {/* <span className="error" ng-show="personForm.address.$error.required">*</span> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="name" value={this.state.ClientFullName} className="form-control" maxLength="50" name="name" type="text" readOnly={this.state.readOnlyFlag} required placeholder="Beneficiary Name" onChange={this.onChange.bind(this)} />
                                                            {/* <span className="error" ng-show="personForm.name.$error.required">*</span> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="mobile" value={this.state.ClientPhone} className="form-control" maxLength="100" name="mobile" type="text" readOnly={this.state.readOnlyFlag} required placeholder="Beneficiary Phone" onChange={this.onChange.bind(this)} />
                                                            {/* <span className="error" ng-show="personForm.mobile.$error.required">*</span> */}
                                                            {/* <span className="error" ng-show="personForm.mobile.$error.mobile">Invalid mobile!</span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-2 addressDiv">
                                                    <div className="col-md-8 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="address" value={this.state.ClientAddress} className="form-control" maxLength="75" name="address" type="text" readOnly={this.state.readOnlyFlag} required placeholder="Beneficiary Address (include City, State, and ZIP Code)" onChange={this.onChange.bind(this)} />
                                                            {/* <span className="error" ng-show="personForm.address.$error.required">*</span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-md-12 ">
                                                        <div className="custom-control custom-checkbox">
                                                            <input type="checkbox" checked={this.state.repChkBox} className="custom-control-input" id="defaultUnchecked" disabled={this.state.readOnlyFlag} onChange={this.ChkRepresentive.bind(this)} />
                                                            <span className="custom-control-indicator"></span>
                                                            <label className="custom-control-label" htmlFor="defaultUnchecked">Are you the authorized representative ?</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-2 mb-2">
                                                    <div className="col-md-4" style={{ display: this.state.showRepresentive }}>
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="representative" value={this.state.RepName} className="form-control" maxLength="75" name="representative" type="text" readOnly={this.state.readOnlyFlag} placeholder="Representative’s Name" onChange={this.onChange.bind(this)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4" style={{ display: this.state.showRepresentive }}>
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="relationship" value={this.state.RepRelationship} className="form-control" maxLength="30" name="relationship" type="text" readOnly={this.state.readOnlyFlag} placeholder="Your Relationship to the Beneficiary" onChange={this.onChange.bind(this)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="pm_hm_article">
                                    <div className="container">
                                        <div className="row" style={{ border: "#188fa6 1px solid" }}>
                                            <div className="col-md-12" style={{ background: "#188fa6", color: "#FFFFFF", "textAlign": "center", padding: "10px", textAlign: "left" }}>
                                                Meeting Preferences
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row mt-2 mb-2">
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="appointmentDate" value={this.state.AppointmentDate} className="form-control" maxLength="100" name="appointmentDate" type="text" readOnly={this.state.readOnlyFlag} placeholder="Appointment Requested Date and Time" onChange={this.onChange.bind(this)} />
                                                            {/* <span className="error" ng-show="personForm.name.$error.required">*</span> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="meetingLocation" value={this.state.MeetingLocation} className="form-control" maxLength="100" name="meetingLocation" type="text" readOnly={this.state.readOnlyFlag} placeholder="Meeting Location" onChange={this.onChange.bind(this)} />
                                                            {/* <span className="error" ng-show="personForm.mobile.$error.required">*</span> */}
                                                            {/* <span className="error" ng-show="personForm.mobile.$error.mobile">Invalid mobile!</span> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="pm_hm_article" >
                                    <div className="container">
                                        <div className="row" style={{ border: "#188fa6 1px solid" }}>
                                            <div className="col-md-12" style={{ background: "#188fa6", color: "#FFFFFF", "textAlign": "center", padding: "10px", textAlign: "left" }}>
                                                Beneficiary / Authorized Representative Signature and Signature Date
                                            </div>
                                            <div className="col-md-6" style={this.state.SignPadReadOnly}>
                                                <div className="containersign" style={{ display: this.state.showSignPad }}>
                                                    {/* <signature-pad accept="accept" clear="clear" height="150px" width="520px" dataurl="dataurl" style={{height:"200px", width:"100%"}}></signature-pad> */}

                                                    <SignaturePad
                                                        ref={ref => this.signaturePad = ref}
                                                        redrawOnResize={true}
                                                    />
                                                </div>
                                                {this.state.showAppointmentDtls === "block" ?
                                                    <div className="signImg">
                                                        <img src={`data:image/jpeg;base64,${this.props.clientDetails.ClientSignature}`} />
                                                    </div>
                                                    : null}
                                                <div className="buttons">
                                                    <div className="row">
                                                        <button type="button" disabled={this.state.readOnlyFlag} onClick={this.signClear.bind(this)}>Clear</button>
                                                        <p className="tip mb-0 mt-2 ml-2"><strong>Tip:</strong> Use mouse or touchscreen to draw your signature</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2" style={{ "textAlign": "left", "fontSize": "15px" }}>
                                                <p>Signature Date  :  <span>{this.state.SignatureDate}</span></p>
                                                <p>IP Address  :  <span>{this.state.IPAddress}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="pm_hm_article" style={{ display: this.state.showAppointmentDtls }}>
                                    <div className="container">
                                        <div className="row" style={{ border: "#188fa6 1px solid" }}>
                                            <div className="col-md-12" style={{ background: "#188fa6", color: "#FFFFFF", "textAlign": "center", padding: "10px", textAlign: "left" }}>
                                                Appointment details to be completed by Agent
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row mt-2 mb-2">
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="initialMethodOfContact" value={this.state.initialMethodOfContact} className="form-control" maxLength="50" name="initialMethodOfContact" type="text" placeholder="Initial Method of Contact" onChange={this.onChange.bind(this)} />
                                                            {/* <span className="error" ng-show="personForm.name.$error.required">*</span> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            <input id="plansAgentRepresented" value={this.state.plansAgentRepresented.replace(",  ", " ")} className="form-control" maxLength="150" name="plansAgentRepresented" type="text" placeholder="Plan(s) the agent represented during this meeting" onChange={this.onChange.bind(this)} />
                                                            {/* <span className="error" ng-show="personForm.mobile.$error.required">*</span> */}
                                                            {/* <span className="error" ng-show="personForm.mobile.$error.mobile">Invalid mobile!</span> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 ">
                                                        <div className="pm_download_mobileapp_content1">
                                                            {/* <input id="dateAppointmentCompleted" className="form-control" maxLength="100" name="dateAppointmentCompleted" type="date" placeholder="Date Appointment Completed" onChange={this.onChange.bind(this)} /> */}
                                                            <DatePickerInput
                                                                id={"datepicker"}
                                                                value={this.state.dateAppointmentCompleted}
                                                                className='my-custom-datepicker-component'
                                                                onChange={this.onCalenderChange.bind(this)}
                                                                showOnInputClick={true}
                                                            //returnFormat={"MM/DD/YYYY"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="pm_hm_article">
                                    <div className="container">
                                    </div>
                                    <div className="row">
                                        <button type="button" id="close-window" className="pm_landingview_btn" onClick={this.chkValidation.bind(this)}><span>SUBMIT & DOWNLOAD</span></button>
                                        {/* <button onClick={this.closeMe.bind(this)}>Close</button> */}
                                    </div>
                                    <div className="row notAgent">
                                        <h5>By clicking submit you are agreeing to the Terms and Conditions</h5>
                                    </div>
                                </section>

                            </form>
                        </div>
                    }

                    {
                        this.state.showPopup ?
                            <Popup
                                getResult={this.getPopupResult.bind(this)}
                                pageNum={2}
                            />
                            : null
                    }

                    {
                        this.state.alertShowPopup && ((this.props.soaid !== "" && this.props.IsAgent === false) || this.props.soaid === "") ?
                            <AlertPopup
                                alertPopUpResult={this.getAlertPopupResult.bind(this)}
                                agentDetails={this.props.agentDetails}
                                help={this.state.help}
                                config={this.props.config}
                            />
                            : null
                    }

                    {
                        this.state.alertShowPopup && (this.props.soaid !== "" && this.props.IsAgent === true) ?
                            <Popup1
                                alertPopUpResult={this.getAlertPopupResult.bind(this)}
                                agentDetails={this.props.agentDetails}
                                help={this.state.help}
                                config={this.props.config}
                            />
                            : null
                    }
                </Loader >
            </div >
        );
    }
}

export default SubmitSOA;